import React, { Component } from "react";
import { modalhandler } from "../actions/modal-handler";
import { bindActionCreators } from "redux";
import { app } from "../index";
import { connect } from "react-redux";
import { datapop } from "../actions/data-populate";
import { Tab } from "semantic-ui-react";
import { grabservice } from "../services/crudservice";
import EstimateApprove from "../components/jobtrack/estimate-manage";
import CLosedJobs from "../components/jobtrack/closed-jobs";
import JobInfo from "../components/jobtrack/jobinfo";
class JTAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
      salarycodes: null,
      locations: null,
      resetpassmessage: false
    };
  }
  componentDidMount() {
    this.gensalaryoptions();
    this.genlocations();
  }
  componentDidUpdate(prevProps, prevState) {
    this.props.datapop("hradmin", "AccessRequest");
    console.log(this.props.params.tabindex);
    if (!this.state.materials.length) {
      this.setmaterials();
    }
  }
  gensalaryoptions() {
    grabservice("salarycodes").then(results => {
      if (results.data) {
        results = results.data;
      }
      console.log(results);
      this.setState({ salarycodes: results });
    });
  }
  resetuserpassword(userid) {
    app.service("login").patch(userid, {
      password: "edfinc",
      passwordreset: true
    });
  }
  genlocations() {
    console.log("getting locations");
    grabservice("location").then(results => {
      console.log(results);
      if (results.data) {
        results = results.data;
      }
      this.setState({ locations: results });
    });
  }
  setmaterials() {
    //export const grabservice = service => {

    grabservice("materials").then(results => {
      if (results.data) {
        results = results.data;
      }
      this.setState({ materials: results });
    });
  }

  render() {
    // {
    //   name: "Update Job Info"
    // },
    // {
    //   name: "EditApprove Estimate"
    // },
    // {
    //   name: "Closed Jobs Assigned"
    // }
    const panes = [
      {
        menuItem: "Update Job Info",
        render: () => (
          <div>
            <JobInfo />
          </div>
        )
      },
      {
        menuItem: "Edit / Approve Estimate",
        render: () => (
          <div>
            <EstimateApprove />
          </div>
        )
      },
      {
        menuItem: "Closed Jobs Assigned",
        render: () => (
          <div>
            <CLosedJobs />
          </div>
        )
      }
    ];
    const tabs = ["job-info", "estimate-edit", "jobs"];
    if (this.props.employees.length) {
      //  this.props.modalhandler("none");
      return (
        <div className="JTAdmin">
          <Tab
            panes={panes}
            menu={{ secondary: true, pointing: true }}
            defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
            onTabChange={(e, data) => {
              console.log(data);
            }}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }
}
function mapStateToProps(state) {
  return {
    fixedwods: state.workorders.fixedwods,
    wods: state.workorders.derivitives,
    customers: state.custinfo.customers,
    employees: state.employees.employees,
    jobs: state.jobs.assignedjobs,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      datapop: datapop,
      modalhandler: modalhandler
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(JTAdmin);



// WEBPACK FOOTER //
// ./src/containers/JTAdmin.js